import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  a {
    width: 100%;
  }

  @media (max-width: 750px) {
    height: 100%;
  }
`;
